import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import { thousandSeparator } from '../../utils/Utils'
import { Rub } from '../app-icon/Icons'

const styles = theme => ({
  grid: {
    margin: '0 5px',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  gridLargeItem: {
    width: '50%',
    display: 'flex',
    padding: 5,
    position: 'relative',
    '& $brick': {
      padding: '16px 5px 12px 5px',
      width: '100%',
      height: 0,
      paddingBottom: '37.25%',
    },
  },
  gridSmallItem: {
    display: 'flex',
    width: '25%',
    minWidth: 305,
    padding: '5px',
    '& $brick': {
      width: '100%',
      height: 0,
      paddingBottom: '23.25%',
    },
  },
  brick: {
    position: 'relative',
    padding: '20px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    flex: '1 1 auto',
  },
  brickTitle: {
    fontSize: 16,
    marginBottom: 8,
  },
  brickSubTitle: {
    display: 'block',
    fontSize: '12px',
    marginBottom: 8,
  },
  brickTotal: {
    fontSize: '33px',
    whiteSpace: 'nowrap',
  },
  chartBox: {
    marginTop: 35,
    position: 'absolute',
    left: 10,
    right: 20,
    top: 50,
    bottom: 15,
  },
  brickNoData: {
    backgroundColor: 'rgb(248, 248, 248)',
    '& $brickTotal': {
      fontSize: 18,
      fontWeight: 'normal',
      fontStyle: 'normal',
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: 'rgba(0, 0, 0, 0.4)',
      textTransform: 'uppercase',
    },
  },
  hintIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    display: 'block',
    width: 24,
    height: 24,
    border: '1px solid rgb(136, 102, 255)',
    borderRadius: '50%',
    lineHeight: '23px',
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    cursor: 'pointer',
    backgroundColor: 'rgb(136, 102, 255)',
  },
  hintHelp: {
    textAlign: 'left',
    padding: '4px 8px',
  },
  brickDescription: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
})

class MGrid extends Component {
  state = {
    openTooltip: false,
  }
  render() {
    const { summaryData, classes, costChart, revenueChart } = this.props

    return (
      <div className={classes.grid}>
        <div className={classes.gridLargeItem}>
          <div className={classes.brick}>
            <div className={classes.brickTitle}>Расходы на рекламу</div>
            <div className={classes.brickTotal}>
              {thousandSeparator(summaryData.cost)}
              <Rub width={26} height={20} />
            </div>
            <div className={classes.chartBox}>{costChart}</div>
          </div>
        </div>
        <div className={classes.gridLargeItem}>
          <div className={classes.brick}>
            <div className={classes.brickTitle}>Выручка</div>
            <div className={classes.brickTotal}>
              {thousandSeparator(summaryData.revenue)}
              <Rub width={26} height={20} />
            </div>
            <div className={classes.chartBox}>{revenueChart}</div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>Показы</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.impressions)}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>Сеансы</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.sessions)}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>Заявки</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.leads)}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>Продажи</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.orders)}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <Tooltip
              interactive
              disableFocusListener
              PopperProps={{
                disablePortal: true,
              }}
              classes={{
                tooltip: classes.hint,
                popper: classes.popper,
              }}
              title={
                <Fragment>
                  <div className={classes.hintHelp}>
                    (Cost Per Click) - это цена клика, сумма, которую
                    рекламодатель платит рекламной системе за клик по
                    объявлению, сделанный пользователем. Среднее значение
                    рассчитывается как (Сумма затрат на рекламу в рекламной
                    системе)/(Количество кликов).
                  </div>
                </Fragment>
              }
            >
              <span className={classes.hintIcon}>?</span>
            </Tooltip>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>CPC</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.cpc)}
                <Rub width={26} height={20} />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <Tooltip
              interactive
              disableFocusListener
              PopperProps={{
                disablePortal: true,
              }}
              classes={{
                tooltip: classes.hint,
                popper: classes.popper,
              }}
              title={
                <Fragment>
                  <div className={classes.hintHelp}>
                    (Cost Per Action) - стоимость целевого действия. Действие
                    определяет рекламодатель, это может быть заполненная форма
                    на сайте, целевой звонок или любое другое действие,
                    интересное рекламодателю.
                  </div>
                </Fragment>
              }
            >
              <span className={classes.hintIcon}>?</span>
            </Tooltip>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>CPA</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.cpa)}
                <Rub width={26} height={20} />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <Tooltip
              interactive
              disableFocusListener
              PopperProps={{
                disablePortal: true,
              }}
              classes={{
                tooltip: classes.hint,
                popper: classes.popper,
              }}
              title={
                <Fragment>
                  <div className={classes.hintHelp}>
                    (Cost Per Order) - стоимость оформленного заказа.
                    Рассчитывается как (Сумма затрат на рекламу в рекламной
                    системе)/(Количество заказов)
                  </div>
                </Fragment>
              }
            >
              <span className={classes.hintIcon}>?</span>
            </Tooltip>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>CPO</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.cpo)}
                <Rub width={26} height={20} />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.gridSmallItem}>
          <div className={classes.brick}>
            <Tooltip
              interactive
              disableFocusListener
              PopperProps={{
                disablePortal: true,
              }}
              classes={{
                tooltip: classes.hint,
                popper: classes.popper,
              }}
              title={
                <Fragment>
                  <div className={classes.hintHelp}>
                    (Return On Marketing Investment) - показатель эффективности
                    рекламных кампаний, рассчитывается как (Доход по рекламному
                    каналу)/(Расход по рекламному каналу)
                  </div>
                </Fragment>
              }
            >
              <span className={classes.hintIcon}>?</span>
            </Tooltip>
            <div className={classes.brickDescription}>
              <div className={classes.brickTitle}>ROMI</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(summaryData.romi)} %
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(MGrid)
